module.exports = __webpack_public_path__ + "img/dy_51@2x.c514a855.png";